import React from "react";
import { useTranslation } from "react-i18next";

const EducationTable = (props) => {
    const { t } = useTranslation();


    const viewData =(data)=>{
        if(props?.type==='video'){
            props.viewVideo(data)
            return

        }

        window.open(data?.documentFile);
        
    }
    return (
        <div className="table-wrapper px-3 pt-3">
            <p className="table-type">{t("admin.education.table.allType", { type: props?.type })}</p>
            <div className="table-wrapper-scroll-y table-scrollbar">
                <div className="table-own table-responsive">
                    <table className="table table-striped table-hover table-admin">
                        <thead className="table-head">
                            <tr>
                                <th
                                    className={`sort-header cursor ${props?.sortObj?.sortVal === "storeName" ? "active" : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                    // onClick={() => props.arraySorting("storeName")}
                                >
                                    <span>{t("common.title")}</span>{" "}
                                    {props?.sortObj?.sortType === "aesc" && (
                                        <i className="fas fa-caret-down"></i>
                                    )}
                                    {props?.sortObj?.sortType === "desc" && (
                                        <i className="fas fa-caret-up"></i>
                                    )}
                                </th>
                                {/* {props?.type==='video' &&
                                <th
                                    className={`sort-header cursor ${props?.sortObj?.sortVal === "address" ? "active" : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                    onClick={() => props.arraySorting("address")}
                                >
                                    <span>Author</span>{" "}
                                    {props?.sortObj?.sortType === "aesc" && (
                                        <i className="fas fa-caret-down"></i>
                                    )}
                                    {props?.sortObj?.sortType === "desc" && (
                                        <i className="fas fa-caret-up"></i>
                                    )}
                                </th>} */}
                                <th className="text-center">
                                    <span>{t("common.view")}</span>
                                </th>
                                <th>
                                    <span>{t("common.status")}</span>
                                </th>
                                <th>
                                    <span>{t("common.action")}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {props.dataList.map((data) => {

                                return (
                                    <tr key={data?.educationId}>
                                        <td>{props?.type==='video'?data?.videoTitle:data?.documentTitle}</td>
                                        {/* {props?.type==='video' &&<td>{data?.videoAuthor}</td>} */}

                                        <td className="text-center">
                                            <div
                                                className="cursor"
                                                onClick={() => viewData(data)}
                                            >
                                                <i className="far fa-eye primary-color"></i>
                                            </div>
                                        </td>
                                        <td className="table-data-status">
                                            {data?.isActive ? (
                                                <span className="table-isactive">{t("common.active")}</span>
                                            ) : (
                                                <span className="table-isinactive">{t("common.inactive")}</span>
                                            )}
                                        </td>
                                        <td className="nowrap">
                                            <span
                                                className="ml-1 mr-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                                                onClick={() => props?.toggleData(data?.educationId)}
                                            >
                                                {data?.isActive ? t("common.inactivate") : t("common.activate")}
                                            </span>{" "}
                                            |{" "}
                                            <span
                                                className="ml-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                                                onClick={() => props.deleteData(data)}
                                            >
                                                {t("common.delete")}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default EducationTable;
